import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import InputMask from 'react-input-mask';
import { es, enGB, pt, fr, de } from 'date-fns/locale';

import {
  getActualDate,
  getDateFromString,
  getSameTimeDay,
  isSameDate
} from '../../commons/datesUtils';

import 'react-datepicker/dist/react-datepicker.css';
import './DateSelector.css';

registerLocale('es', es);
registerLocale('en', enGB);
registerLocale('pt', pt);
registerLocale('fr', fr);
registerLocale('de', de);

class DateSelector extends React.Component {
  static propTypes = {
    tabIndex: PropTypes.string,
    title: PropTypes.string,
    dataTestLabel: PropTypes.string,
    defaultDate: PropTypes.string,
    localeLang: PropTypes.string,
    readOnly: PropTypes.bool,
    isDisabled: PropTypes.bool,
    maxDate: PropTypes.string,
    minDate: PropTypes.string,
    checkPrevProps: PropTypes.bool,
    edited: PropTypes.bool,
    handleDateSelected: PropTypes.func
  }

  static defaultProps = {
    tabIndex: '0',
    title: '',
    dataTestLabel: '',
    defaultDate: getActualDate(true),
    localeLang: 'es',
    readOnly: false,
    isDisabled: false,
    maxDate: undefined,
    minDate: undefined,
    checkPrevProps: false,
    edited: false,
    handleDateSelected: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      value: getDateFromString(this.props.defaultDate),
      defaultLang: this.props.localeLang
    };
  }

  componentDidUpdate(prevProps) {
    const { checkPrevProps, defaultDate } = this.props;

    if (!checkPrevProps) return;

    if (isSameDate(prevProps.defaultDate, defaultDate)) return;

    this.setStateOnly(getDateFromString(defaultDate));
  }

  setStateOnly = (value) => {
    this.setState({ value });
  }

  onDateSelected = (value) => {
    const { minDate, maxDate, handleDateSelected } = this.props;
    
    const parsedDate = getSameTimeDay(value);
    const parsedMinDate = getSameTimeDay(getDateFromString(minDate));
    const parsedMaxDate = getSameTimeDay(getDateFromString(maxDate));

    if (minDate && typeof minDate === 'string'
      && !parsedDate.isSameOrAfter(parsedMinDate)) {
      return;
    }

    if (maxDate && typeof maxDate === 'string'
      && !parsedDate.isSameOrBefore(parsedMaxDate)) {
      return;
    }

    this.setState({
      value
    }, () => {
      handleDateSelected(parsedDate.format('DD/MM/YYYY'));
    });
  }

  render() {
    const {
      tabIndex,
      title,
      dataTestLabel,
      defaultDate,
      maxDate,
      minDate,
      readOnly,
      isDisabled,
      edited
    } = this.props;

    const { value, defaultLang } = this.state;

    const customClassName = `component-container ${edited ? 'edited' : ''}`;

    return (
      <Row className="selector-date__component auto-margin">
        <Col sm="12" className="component-title no-padding-left">
          {title}
        </Col>
        <Col sm="12" className="component-form no-padding-left">
          {(readOnly)
            ?
              <label className="read-only-label">
                {defaultDate}
                <span className="icon-calendar" />
              </label>
            :
              <div className={customClassName} data-test-id={dataTestLabel}>
                <DatePicker
                  tabIndex={tabIndex}
                  dateFormat="dd/MM/yyyy"
                  selected={value}
                  minDate={getDateFromString(minDate)}
                  maxDate={getDateFromString(maxDate)}
                  onSelect={this.onDateSelected}
                  disabledKeyboardNavigation
                  allowSameDay
                  locale={defaultLang}
                  disabled={isDisabled}
                  isClearable={false}
                  customInput={<InputMask mask="99/99/9999" />}
                />
                {!isDisabled && <span className="icon-calendar" />}
              </div>
            }
          </Col>
      </Row>
    );
  }
}

export default DateSelector;
